///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy,
    Injector,
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { map } from "rxjs/operators/map";

import { TranslationsProvider } from "../../../core/translations.provider";
import { ModelDataResult } from "../../../core/data/model-data-result";
import { AuthorizationService } from "../../../core/auth/authorization.service";
import { DataService } from "../../../core/data/data.service";
import { DataServiceFactory } from "../../../core/data/data-service-factory";

import { State } from "@progress/kendo-data-query";

import { NotificationService } from "./../../../core/notification/notification.service";
import { Notification } from "./../../../core/notification/notification";

@Component({
    selector: "kb-app-layout",
    templateUrl: "./app-layout.view.component.html",
    styleUrls: ["./app-layout.view.component.css"],
})
export class AppLayoutViewBaseComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    public $authorizationService: AuthorizationService;
    public $dataServices: { [key: string]: DataService<any> };
    public $dataServicesData: { [key: string]: Observable<any> };
    public $dataServicesResult: {
        [key: string]: BehaviorSubject<ModelDataResult<any>>;
    };
    public $notificationService: NotificationService;

    public $dataServicesState: { [key: string]: State } = {};

    public $dataModels: any = {};
    public $config: any = {
        components: {
            customhtml0: {},

            languagesDdl: {
                data: this.getLanguages(),
                textField: "label",
                valueField: "key",
            },
            customDrodown: {},

            navigationpanelbar0: {},
        },
    };

    public $navigationData = [
        {
            title: "Booking",
            titleKey: "modules.Booking.label",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-pie-chart",
            },
            children: [
                {
                    title: "SupplierData",
                    titleKey: "modules.Booking.views.SupplierData.label",
                    label: "Supplier Data",
                    routerLink: "/booking/supplier-data",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ],
        },
        {
            title: "Historical Bookings",
            titleKey: "modules.HistoricalBookings.label",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-pie-chart",
            },
            children: [
                {
                    title: "SupplierData",
                    titleKey:
                        "modules.HistoricalBookings.views.SupplierData.label",
                    label: "Supplier Data",
                    routerLink: "/historical-bookings/supplier-data",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ],
        },
        {
            title: "Contact",
            titleKey: "modules.Contact.label",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-drivers-license-o",
            },
            children: [
                {
                    title: "ContactInfo",
                    titleKey: "modules.Contact.views.ContactInfo.label",
                    label: "Contact Info",
                    routerLink: "/contact/contact-info",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ],
        },
        {
            title: "GroupBooking",
            titleKey: "modules.GroupBooking.label",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-pie-chart",
            },
            children: [
                {
                    title: "SupplierData",
                    titleKey: "modules.GroupBooking.views.SupplierData.label",
                    label: undefined,
                    routerLink: "/group-booking/supplier-data",
                    authorization: {
                        allowedRoles: [],
                    },
                },
                {
                    title: "SupplierDataDetails",
                    titleKey:
                        "modules.GroupBooking.views.SupplierDataDetails.label",
                    label: undefined,
                    routerLink: "/group-booking/supplier-data-details",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ],
        },
        {
            title: "ExchangePoint",
            titleKey: "modules.ExchangePoint.label",
            thumbnail: {
                background: "#1d75eb",
                color: "#1c4284",
                icon: "fa-coffee",
            },
            children: [
                {
                    title: "ExchangePoint",
                    titleKey: "modules.ExchangePoint.views.SupplierData.label",
                    label: undefined,
                    routerLink: "/exchange-point/supplier-data",
                    authorization: {
                        allowedRoles: [],
                    },
                },
            ],
        },
    ];

    constructor(public injector: Injector) {
        this.$authorizationService = this.injector.get(AuthorizationService);
        this.$notificationService = this.injector.get(NotificationService);

        const dsConfig = this.getDataServicesConfig();
        this.$dataServices = {};

        this.$dataServicesData = {};

        this.$dataServicesResult = {};
        this.filterNavigationData();

        const translationsProvider = this.injector.get(TranslationsProvider);
        translationsProvider.useDefaultLanguage();
    }

    public ngOnInit(): void {
        this["onInit"]();

        for (const dataSourceName of Object.keys(this.$dataServices)) {
            this.read(dataSourceName);
            this.dataServiceErrors(dataSourceName);
        }
    }

    public ngAfterViewInit(): void {
        this["onShow"]();
    }

    public ngOnDestroy(): void {
        this["onHide"]();
    }

    public getLanguages(): any[] {
        return [
            {
                label: "English",
                culture: "en-GB",
                order: 0,
                key: "translations.default",
            },
            {
                label: "Nederlands",
                culture: "nl-NL",
                order: 0,
                key: "translations.dutch",
            },
            {
                label: "English",
                culture: "en-GB",
                order: 0,
                key: "translations.english",
            },
            {
                label: "Francais",
                culture: "fr-FR",
                order: 0,
                key: "translations.french",
            },
            {
                label: "Deutsch",
                culture: "de-DE",
                order: 0,
                key: "translations.german",
            },
            {
                label: "Italiano",
                culture: "it-IT",
                order: 0,
                key: "translations.italian",
            },
            {
                label: "Romana",
                culture: "ro",
                order: 0,
                key: "translations.romanian",
            },
        ];
    }

    private filterNavigationData(): void {
        this.$navigationData.forEach((module) => {
            const views = module.children.filter((view) =>
                this.$authorizationService.isAuthorized(view.authorization)
            );
            module.children = views;
        });

        this.$navigationData = this.$navigationData.filter(
            (module) => module.children.length
        );
    }

    public read(dataSourceName): void {
        this.$dataServices[dataSourceName].read();
    }

    public getDataChanges(dataSourceName): Observable<any[]> {
        const dataService = this.$dataServices[dataSourceName];
        return dataService
            .dataChanges()
            .pipe(map((response) => (response ? response.data : [])));
    }

    public getDataResult(
        dataSourceName
    ): BehaviorSubject<ModelDataResult<any>> {
        return this.$dataServices[dataSourceName].dataChanges();
    }

    public dataServiceErrors(dataSourceName): void {
        this.$dataServices[dataSourceName].errors.subscribe((err: any) => {
            if (err) {
                const message = (err.error && err.error.message) || err.message;
                this.$notificationService.notify(
                    new Notification(
                        `<ul><li>${message}<li></ul>`,
                        "error",
                        10000
                    )
                );
            }
        });
    }

    protected getDataServicesConfig() {
        const config = {};

        return config;
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/app-layout/app-layout.view.base.component.ts